





































import { Vue, Component, Prop } from 'vue-property-decorator';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import { Twilio, ETwilioAction } from '@signing-page/integrations/twilio/store/twilio.constants';
import { EButtonTypes } from '@/enums/ButtonType';
import { IRecipient } from '@signing-page/documents/types/recipient';
import { testMobileNumber } from '@/common/helpers';

@Component({
  components: {
    Input,
    Button,
  },
  data: () => ({
    EButtonTypes,
  }),
})
export default class PhoneModal extends Vue {
  @Twilio.State('callSid') callSid: string;
  @Twilio.State('error') error: string;
  @Twilio.State('loading') loading: boolean;
  @Twilio.Action(ETwilioAction.CallPhone) callPhone: any;
  @Twilio.Action(ETwilioAction.CancelCall) cancelCall: any;

  @Prop() recipient: IRecipient;

  phoneNumber: string = this.recipient?.mobile || '';
  invalid = false;
  completed = false;

  get calling(): boolean {
    return !!this.callSid;
  }

  checkPhone() {
    if (this.phoneNumber.length === 0) {
      this.invalid = false;
      this.completed = false;
      return;
    }
    if (testMobileNumber(this.phoneNumber)) {
      this.invalid = false;
      this.completed = true;
      return;
    }

    this.invalid = true;
    this.completed = false;
  }

  handleClose() {
    this.$emit('close');
  }

  handleCancelCall() {
    this.cancelCall();
  }

  handleCallPhone() {
    this.callPhone(this.phoneNumber);
  }

  mounted() {
    this.checkPhone();
  }
}
